/**
 * Util function to check if a string is falsy (undefined or null), is empty or contains only whitespace
 */
export const isStringBlank = (value: string | null | undefined): boolean => {
	return !value || value.trim().length === 0;
};
